import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import "./contactForm.scss";

const EMPTY_FORM = { name: "", email: "", subject: "", message: "" };

export default function ContactForm() {
  const [form, setForm] = useState(EMPTY_FORM);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState({ type: "", message: "" });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((currentForm) => ({ ...currentForm, [name]: value }));
    if (status.message) setStatus({ type: "", message: "" });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setStatus({ type: "", message: "" });

    try {
      await emailjs.send(
        process.env.REACT_APP_SERVICE_ID,
        process.env.REACT_APP_TEMPLATE_ID,
        {
          from_name: form.name.trim(),
          to_name: "Abilasha",
          from_email: form.email.trim(),
          subject: form.subject.trim(),
          message: form.message.trim(),
        },
        process.env.REACT_APP_PUBLIC_KEY,
      );

      setForm(EMPTY_FORM);
      setStatus({ type: "success", message: "Thanks! Your message has been sent." });
    } catch (error) {
      console.error("Contact form submission failed", error);
      setStatus({ type: "error", message: "Your message could not be sent. Please try again or contact me by email." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="emailForm">
      <label htmlFor="contact-name"> <span aria-hidden="true">*</span></label>
      <input
        id="contact-name"
        name="name"
        type="text"
        placeholder="Your Name"
        autoComplete="name"
        maxLength={100}
        value={form.name}
        onChange={handleChange}
        required
      />

      <label htmlFor="contact-email"> <span aria-hidden="true">*</span></label>
      <input
        id="contact-email"
        name="email"
        type="email"
        placeholder="you@example.com"
        autoComplete="email"
        maxLength={254}
        value={form.email}
        onChange={handleChange}
        required
      />

      <label htmlFor="contact-subject"></label>
      <input
        id="contact-subject"
        name="subject"
        type="text"
        placeholder="What would you like to discuss?"
        maxLength={150}
        value={form.subject}
        onChange={handleChange}
      />

      <label htmlFor="contact-message"><span aria-hidden="true">*</span></label>
      <textarea
        id="contact-message"
        name="message"
        rows={6}
        placeholder="Tell me a little about your project..."
        maxLength={5000}
        value={form.message}
        onChange={handleChange}
        required
      />

      <p className={`contact-form-status${status.type ? ` contact-form-status--${status.type}` : ""}`} role="status" aria-live="polite">
        {status.message}
      </p>

      <button type="submit" className="form-btn" disabled={loading}>
        {loading ? "Sending..." : "Send message"}
      </button>
    </form>
  );
}
